import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { type TopCollectorsProps } from './types';
import Collector from './Collectors';
import {
  TopCollectorsSection,
  TopCollectorsHeadline,
  TopCollectorsList,
} from './styled';

const TopCollectors: FC<TopCollectorsProps> = ({ list }) => {
  const { t } = useTranslation();

  return (
    <TopCollectorsSection data-test-id="top_collectors_wrapper">
      <TopCollectorsHeadline
        data-test-id="top_collectors_headline"
        font="secondary"
        textColor="primary"
        size="header2"
        lSpacing={2}
        uppercase
        as="h2"
      >
        {t('collection.topCollectors')}
      </TopCollectorsHeadline>

      <TopCollectorsList data-test-id="top_collectors_list">
        {list.map((collector, index) => (
          <Collector collector={collector} index={index + 1} key={collector.id} />
        ))}
      </TopCollectorsList>
    </TopCollectorsSection>
  );
};

export default TopCollectors;
